import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import Logo from './Logo';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const goToSection = (id) => {
    setMenuOpen(false);
    if (location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 60);
    }
  };

  return (
    <nav className={`site-nav${scrolled ? ' scrolled' : ''}`}>
      <div className="site-nav-inner">
        <Link className="site-logo" to="/" aria-label="Go to home page">
          <Logo size={32} idPrefix="nav" />
          <span className="site-logo-text">Sunsoft<span className="site-logo-accent">Gaming</span></span>
        </Link>

        <button className="site-burger" onClick={() => setMenuOpen(v => !v)} aria-label="Menu">
          <span /><span /><span />
        </button>

        <ul className={`site-nav-links${menuOpen ? ' open' : ''}`}>
          <li><NavLink to="/" end onClick={() => setMenuOpen(false)}>Home</NavLink></li>
          <li><NavLink to="/games" onClick={() => setMenuOpen(false)}>Games</NavLink></li>
          <li><button onClick={() => goToSection('about')}>About</button></li>
          <li>
            <Link className="site-nav-cta" to="/games">Play Now</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
